module.exports = __webpack_public_path__ + "img/phone.ddeafd12.svg";